import { createAction, props } from '@ngrx/store';

export const subscribeToStatusBarData = createAction(
    '[Lobby Status Bar] Subscribe To Status Bar Data',
    props<{ tenantId: number, locationId: number }>()
);
